module.exports = __webpack_public_path__ + "img/Logo_BG.792ab9e4.png";